<script setup lang="ts">
import AvaButton from '@/presentation/components/atoms/AvaButton.vue';
import { useActiveDialog } from '@/presentation/composables/useDialogStack';
import { useToast } from '@/presentation/composables/useToast';
import { colorStyle } from '@/presentation/utils/ui';
const { toasts, dismiss } = useToast();
const activeDialog = useActiveDialog();
</script>
<template>
  <Teleport :to="activeDialog ?? 'body'">
    <ol
      class="toast-stack"
      aria-label="Notificações"
    >
      <li
        v-for="t in toasts"
        :key="t.id"
        class="ava-toast"
        :style="colorStyle(t.variant)"
        :role="t.variant === 'error' ? 'alert' : 'status'"
      >
        <span>{{ t.message }}</span><AvaButton
          icon="mdi-close"
          variant="text"
          size="small"
          aria-label="Fechar notificação"
          @click="dismiss(t.id)"
        />
      </li>
    </ol>
  </Teleport>
</template>
